import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IUploadDirectorDocumentsRequest, IUploadDirectorDocumentsResponse } from '../models/upload-documents.model';

export const loadUploadDocuments = createAction(
  '[UploadDocument] Load UploadDocuments',
  props<{ request: IUploadDirectorDocumentsRequest }>()
);

export const loadUploadDocumentsSuccess = createAction(
  '[UploadDocument] Load UploadDocuments Success',
  props<{ response: IUploadDirectorDocumentsResponse }>()
);

export const loadUploadDocumentsFailure = createAction(
  '[UploadDocument] Load UploadDocuments Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
